export enum TitleManagementMode {
  Mixed = "Mixed",
  Grouped = "Grouped",
}
